import { render, staticRenderFns } from "./oss.vue?vue&type=template&id=5a5c4fa8"
import script from "./oss.vue?vue&type=script&lang=js"
export * from "./oss.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a5c4fa8')) {
      api.createRecord('5a5c4fa8', component.options)
    } else {
      api.reload('5a5c4fa8', component.options)
    }
    module.hot.accept("./oss.vue?vue&type=template&id=5a5c4fa8", function () {
      api.rerender('5a5c4fa8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/resource/oss.vue"
export default component.exports